/**
 * App shell UI — initializer, global toast, loaders, splash, auth overlay host.
 */
import React, { type ComponentProps } from 'react';
import { AppInitializerGate } from './AppInitializerGate';
import { ToastRoot } from '../components/toast/ToastRoot';
import { MainLoader } from '../components/load-main/MainLoader';
import { AppSplashScreen } from '../components/splash/AppSplashScreen';
import { AuthSheetHost } from '../auth/AuthSheetHost';

export function AppInitializer() {
  return <AppInitializerGate />;
}

export function AppToastRoot() {
  return <ToastRoot />;
}

type LoaderProps = ComponentProps<typeof MainLoader>;

export function AppMainLoader(props: LoaderProps) {
  return <MainLoader {...props} />;
}

export function AppSplash(
  props: ComponentProps<typeof AppSplashScreen>,
) {
  return <AppSplashScreen {...props} />;
}

export function AppAuthSheetHost() {
  return <AuthSheetHost />;
}
